// extracted by mini-css-extract-plugin
module.exports = {"punchout":"index-styles-module--punchout--eTay6","punchout2":"index-styles-module--punchout2--DjGzT","head":"index-styles-module--head--3gaYw"};